import { render, staticRenderFns } from "./product-flexible-media.vue?vue&type=template&id=1bb2e476&scoped=true&"
import script from "./product-flexible-media.vue?vue&type=script&lang=js&"
export * from "./product-flexible-media.vue?vue&type=script&lang=js&"
import style0 from "./product-flexible-media.vue?vue&type=style&index=0&id=1bb2e476&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb2e476",
  null
  
)

export default component.exports